import React from 'react';
import StylishHeader from '../components/stylishHeader';

export default function OurFarmsComponent(props) {
  /* eslint-disable react/prop-types */
  const isLargeScreen = props.isLargeScreen;
  const isSmallScreen = props.isSmallScreen;

  return (
    <div>
      {isLargeScreen &&
        <div>
          <StylishHeader headerText="Our farms"/>
          <div id="grandCafeImage" style={{ justifyContent: "center", display: "flex" }}>
              <div style={{ display: "flex", justifyContent: "center", }}>
                  <img src="/img/MainDrinkingLady.jpg" 
                    style={{
                        width: "95%",
                        borderRadius: "20px",
                        borderStyle: "solid",
                        borderWidth: "2px",
                        borderColor: "#8C6E63"
                    }} alt='' />
              </div>
          </div>
        </div>
      }
      {isSmallScreen &&
        <div>
          <StylishHeader headerText="Our farms"/>
          <div id="grandCafeImage" style={{ padding: "20px", justifyContent: "center", display: "flex" }}>
              <img src="/img/MainDrinkingLady.jpg" height="600px" width="80%" 
                  style={{
                      borderRadius: "20px",
                      borderStyle: "solid",
                      borderWidth: "2px",
                      borderColor: "#8C6E63",
                      width: "100%", 
                      height: "100%"
                  }} alt='' />
          </div>
        </div>
      }
      
    </div>
)
}